/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SubscriptionPlanChangedMessage } from '../../models/subscription-plan-changed-message';

export interface GetnotificationsSubscriptionPlanChangedSchema$Params {
}

export function getnotificationsSubscriptionPlanChangedSchema(http: HttpClient, rootUrl: string, params?: GetnotificationsSubscriptionPlanChangedSchema$Params, context?: HttpContext): Observable<StrictHttpResponse<SubscriptionPlanChangedMessage>> {
  const rb = new RequestBuilder(rootUrl, getnotificationsSubscriptionPlanChangedSchema.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<SubscriptionPlanChangedMessage>;
    })
  );
}

getnotificationsSubscriptionPlanChangedSchema.PATH = '/api/hubs/notifications/SubscriptionPlanChanged';
